<template>
	<div class="account-config-wrapper global-card">
		<!-- <div class="account-config-card" style="margin-top: 20px;padding: 20px 32px;">
			<div style="display: flex;align-items: center;">
				<div style="margin-right: 20px;">合作企业</div>
				<el-select v-model="companyvalue" placeholder="请选择合作企业" style="width: 400px;" @change="change">
					<el-option v-for="item in companyData" :key="item.id" :label="item.companyInfo.qichacha_name"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
		</div> -->
		<div  class="breadcrumb ant-breadcrumb" style="display: flex;align-items: center;justify-content: space-between;">
			<div><span  style="font-size: 18px;"><span
					class="ant-breadcrumb-link"> 规则配置 </span></span></div>
					
					<div style="display: flex;align-items: center;"  v-if="!tabShow">
						<!-- <div style="margin-right: 20px;font-size: 14px;">合作企业</div> -->
						<el-select v-model="companyvalue" placeholder="请选择合作企业" :disabled="isshow==true||isshow1==true||isshow2==true||isshow3==true" style="width: 300px;" @change="change">

							<el-option v-for="item in companyData" :key="item.id" :label="item.companyInfo.qichacha_name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
		</div>
		
		
		
		
		<div class="account-config-card">
			<div v-if="tabShow" >
				<div style="font-size: 20px;" class="ts">配置传统任务</div>
				<div style="display: flex;align-items: center;font-size: 18px;margin-top: 20px;">
					<div style="text-align: center;cursor: pointer;margin-right: 100px" @click="handleClick('医院拜访')">
						<img  src="../../assets/s4.png" style="width:64px ;height: 64px;">
						<div class="type-font" >医院拜访</div>
					</div>
					<div style="text-align: center;cursor: pointer;margin-right: 100px" @click="handleClick('客户拜访')">
						<img  src="../../assets/s55.png" style="width:64px ;height: 64px;">
						<div class="type-font" >商业/终端拜访</div>
					</div>
					<div style="text-align: center;margin-right: 100px;cursor: pointer;" @click="handleClick('调研')">
						<img src="../../assets/s1.png" style="width:64px ;height: 64px;">
						<div class="type-font">调研</div>
					</div>
					<div style="text-align: center;margin-right: 100px;cursor: pointer;" @click="handleClick('科室会')">
						<img src="../../assets/s2.png" style="width:64px ;height: 64px;">
						<div class="type-font">科室会</div>
					</div>
					<div style="text-align: center;margin-right: 100px;cursor: pointer;" @click="handleClick('沙龙会')">
						<img src="../../assets/s3.png" style="width:64px ;height: 64px;">
						<div class="type-font">沙龙会</div>
					</div>
				</div> 
				<div style="font-size: 20px;margin-top: 40px;" class="ts">配置远程任务</div>
				<div style="display: flex;align-items: center;font-size: 18px;margin-top: 50px;cursor: pointer;">
					<div style="text-align: center;margin-right: 100px;" @click="handleClick1('拜访')">
						<img  src="../../assets/s4.png" style="width:64px ;height: 64px;">
						<div class="type-font">拜访</div>
					</div>
					<div style="text-align: center;margin-right: 100px;" @click="handleClick1('调研')">
						<img src="../../assets/s1.png" style="width:64px ;height: 64px;">
						<div class="type-font">调研</div>
					</div>
					<div style="text-align: center;margin-right: 100px;" @click="handleClick1('科室会')">
						<img src="../../assets/s2.png" style="width:64px ;height: 64px;">
						<div class="type-font">科室会</div>
					</div> 
					<div style="text-align: center;margin-right: 100px;" @click="handleClick1('沙龙会')">
						<img src="../../assets/s3.png" style="width:64px ;height: 64px;">
						<div class="type-font" >沙龙会</div>
					</div>
				</div>
			</div>
			<div @click="indexclance" v-if="clanceShow" style="cursor: pointer;text-align: right;position: absolute;right: 71px;z-index:99;"><img src="../../assets/s5.png" style="width:25px ;height: 25px;"></div>
			<rangetask v-if="rangetaskShow" :tabPositiontype="tabPositiontype"  ref="child" :type="type" @clancechanges="clancecostPlannedAmountChange($event)" @changes="costPlannedAmountChange($event)"  :companyvalue="companyvalue"></rangetask>
				<div v-show="tabPosition=='医院拜访'">
					<el-tabs v-model="activeName">
						<el-tab-pane label="医院拜访规则" name="first">
							<!-- 显示内容区 -->
							<div v-if="show">
								<div class="tb">
									<div style="flex:0 0 35%;height: 40px;">项目</div>
									<div
										style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
										设置值</div>
									<div style="flex:0 0 30%;text-align: right;height: 40px;">
										<el-button type="primary" size="small" @click="edit(0)">编辑</el-button>
									</div>
								</div>
								<div class="tbody">
									<div class="tr">
										<div class="name">拜访时间段</div>
										<div class="val">{{info.value.time_section}}</div>
									</div>
									<div class="tr">
										<div class="name">最小拜访时长</div>
										<div class="val">{{info.value.min_visit_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">最大拜访时长</div>
										<div class="val">{{info.value.max_visit_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">签到定位点范围</div>
										<div class="val">距离定位点 {{info.value.sign_scope}}米
											以内({{info.value.allowed_drag==1?'允许改变签到地点':'不允许改变签到地点'}})</div>
									</div>
									<div class="tr">
										<div class="name">代表每日拜访同一医生最大次数</div>
										<div class="val">{{info.value.max_everyday_visit_doctor_times}} 次</div>
									</div>
									<!-- 	<div class="tr">
										<div class="name">交通时间校验车速</div>
										<div class="val">{{info.value.validate_speed}} km/h</div>
									</div> -->
									<div class="tr">
										<div class="name">同一任务是否允许多次指派同一医生</div>
										<div class="val" v-if="info.value.same_task_to_doctor=='0'">否</div>
										<div class="val" v-if="info.value.same_task_to_doctor=='1'">是</div>
									</div>
									<div class="tr">
										<div class="name">启用现场照片相似校验</div>
										<div class="val" v-if="info.value.picture_similar_verify=='0' || info.value.picture_similar_verify == undefined">否</div>
										<div class="val" v-if="info.value.picture_similar_verify=='1'">是，相似阈值：{{ info.value.picture_similar_verify_value }}</div>
									</div>
									<div class="tr">
										<div class="name" style="border: 0;">代表拜访频次</div>
										<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													每天拜访最大次数</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.max_everyday_visit_times}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													次</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													连续拜访同一医院不同科室医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_dep_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续拜访同一市不同医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_hospital_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续拜访不同市区医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_city_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续拜访不同省的医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_province_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													连续任务间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.continuous_task_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 编辑内容区 -->
							<div v-if="isshow">
								<el-form ref="form" :model="form" label-width="160px" :rules="rules"
									style="width: 760px;">
									<el-form-item label="拜访时间段">
										<el-time-picker is-range v-model="value1" style="width: 100%;" format="HH:mm"
											value-format="HH:mm" range-separator="至" start-placeholder="开始时间"
											end-placeholder="结束时间" placeholder="选择时间范围" @change="tiem1">
										</el-time-picker>
										<!-- <el-input v-model="form.time_section"></el-input> -->
									</el-form-item>
									<el-form-item label="最小拜访时长">
										<el-input v-model="form.min_visit_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="最大拜访时长">
										<el-input v-model="form.max_visit_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="代表每日拜访同一医生最大次数">
										<el-input v-model="form.max_everyday_visit_doctor_times">
											<template slot="append">次</template>
										</el-input>
									</el-form-item>
									<el-form-item label="签到定位点范围">
										<div style="display: flex;align-items: center;">
											<el-input v-model="form.sign_scope">
												<template slot="append">米</template>
											</el-input>
											<el-checkbox style="margin-left: 20px;" v-model="form.allowed_drag">允许改变签到地点
											</el-checkbox>
										</div>
									</el-form-item>
									<!-- <el-form-item label="交通时间校验车速">
										<el-input v-model="form.validate_speed">
											<template slot="append">km/h</template>
										</el-input>
									</el-form-item> -->
									<el-form-item label="同一任务是否允许多次指派同一医生">
										<el-radio-group v-model="form.same_task_to_doctor">
											<el-radio :label="1">是</el-radio>
											<el-radio :label="0">否</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="启用现场照片相似校验">
										<el-radio-group v-model="form.picture_similar_verify" @input="enableChangePictureSimilar">
											<el-radio :label="1">是</el-radio>
											<el-radio :label="0">否</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="现场照片相似校验阈值" style="margin-bottom: 10px;" v-if="form.picture_similar_verify==1">
										<el-input v-model="form.picture_similar_verify_value" style="width: 100px;" @blur="checkSimilar()" @input="changeMessage($event)"></el-input>
										<p style="margin: 0;line-height:30px;">默认5，数值越小，表示图片相似度越高</p>
									</el-form-item>
									<el-form-item label="代表拜访频次">
										<el-table :data="form.other_rule" style="width: 100%">
											<el-table-column prop="max_everyday_visit_times" label="每天拜访最大次数"
												width="180">
												<template slot-scope="{row}">
													<el-input v-model="row.max_everyday_visit_times">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_dep_interval_time"
												label="连续拜访同一医院不同科室医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_dep_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_hospital_interval_time"
												label="连续拜访同一市不同医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_hospital_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_city_interval_time"
												label="连续拜访不同市区医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_city_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_province_interval_time"
												label="连续拜访不同省的医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_province_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="continuous_task_interval_time" label="连续任务间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.continuous_task_interval_time">
													</el-input>
												</template>
											</el-table-column>
										</el-table>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit(0)">保存</el-button>
										<el-button @click="clance(0)">返回</el-button>
									</el-form-item>
								</el-form>

							</div>
						</el-tab-pane>
						<el-tab-pane label="更新日志" name="second">
							<el-table :data="tableData" style="width: 100%">
								<el-table-column type="index" label="序号" width="50">
								</el-table-column>
								<el-table-column label="操作前配置" width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.new_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column label="操作后配置 " width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.old_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column prop="create_time" width="180" label="操作时间">
								</el-table-column>
								<el-table-column prop="manager.real_name" label="操作人">
								</el-table-column>
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<el-button @click="check(scope.row,0)" type="text" size="small">查看
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div style="text-align: right;margin-top: 50px;">
								<el-pagination @size-change="handleSizeChange" :page-sizes="[20]"
									@current-change="handleCurrentChange" :current-page="cur_page" :page-size="pageNum"
									layout="total,sizes,  prev, pager, next, jumper" :total="totalCount">
								</el-pagination>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>

				<div v-show="tabPosition=='客户拜访'">
					<el-tabs v-model="activeName">
						<el-tab-pane label="商业/终端拜访规则" name="first">
							<!-- 显示内容区 -->
							<div v-if="show">
								<div class="tb">
									<div style="flex:0 0 35%;height: 40px;">项目</div>
									<div
										style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
										设置值</div>
									<div style="flex:0 0 30%;text-align: right;height: 40px;">
										<el-button type="primary" size="small" @click="edit(0)">编辑</el-button>
									</div>
								</div>
								<div class="tbody">
									<div class="tr">
										<div class="name">拜访时间段</div>
										<div class="val">{{info.value.time_section}}</div>
									</div>
									<div class="tr">
										<div class="name">最小拜访时长</div>
										<div class="val">{{info.value.min_visit_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">最大拜访时长</div>
										<div class="val">{{info.value.max_visit_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">签到定位点范围</div>
										<div class="val">距离定位点 {{info.value.sign_scope}}米
											以内({{info.value.allowed_drag==1?'允许改变签到地点':'不允许改变签到地点'}})</div>
									</div>
									<div class="tr">
										<div class="name">代表每日拜访同一医生最大次数</div>
										<div class="val">{{info.value.max_everyday_visit_doctor_times}} 次</div>
									</div>
									<div class="tr">
										<div class="name">同一份资料拜访同一客户当月可使用次数</div>
										<div class="val">{{info.value.current_month_used_times || 0}} 次</div>
									</div>
									<!-- 	<div class="tr">
										<div class="name">交通时间校验车速</div>
										<div class="val">{{info.value.validate_speed}} km/h</div>
									</div> -->
									<div class="tr">
										<div class="name">同一任务是否允许多次指派同一医生</div>
										<div class="val" v-if="info.value.same_task_to_doctor=='0'">否</div>
										<div class="val" v-if="info.value.same_task_to_doctor=='1'">是</div>
									</div>
									<div class="tr">
										<div class="name">启用现场照片相似校验</div>
										<div class="val" v-if="info.value.picture_similar_verify=='0' || info.value.picture_similar_verify == undefined">否</div>
										<div class="val" v-if="info.value.picture_similar_verify=='1'">是，相似阈值：{{ info.value.picture_similar_verify_value }}</div>
									</div>
									<div class="tr">
										<div class="name" style="border: 0;">代表拜访频次</div>
										<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													每天拜访最大次数</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.max_everyday_visit_times}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													次</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													连续拜访同一医院不同科室医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_dep_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续拜访同一市不同医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_hospital_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续拜访不同市区医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_city_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续拜访不同省的医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_province_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													连续任务间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.continuous_task_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 编辑内容区 -->
							<div v-if="isshow">
								<el-form ref="form" :model="form" label-width="160px" :rules="rules"
									style="width: 760px;">
									<el-form-item label="拜访时间段">
										<el-time-picker is-range v-model="value1" style="width: 100%;" format="HH:mm"
											value-format="HH:mm" range-separator="至" start-placeholder="开始时间"
											end-placeholder="结束时间" placeholder="选择时间范围" @change="tiem1">
										</el-time-picker>
										<!-- <el-input v-model="form.time_section"></el-input> -->
									</el-form-item>
									<el-form-item label="最小拜访时长">
										<el-input v-model="form.min_visit_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="最大拜访时长">
										<el-input v-model="form.max_visit_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="代表每日拜访同一医生最大次数">
										<el-input v-model="form.max_everyday_visit_doctor_times">
											<template slot="append">次</template>
										</el-input>
									</el-form-item>
									<el-form-item label="同一份资料拜访同一客户当月可使用次数">
										<el-input v-model="form.current_month_used_times" @input="changeMessage($event)">
											<template slot="append">次</template>
										</el-input>
									</el-form-item>
									<el-form-item label="签到定位点范围">
										<div style="display: flex;align-items: center;">
											<el-input v-model="form.sign_scope">
												<template slot="append">米</template>
											</el-input>
											<el-checkbox style="margin-left: 20px;" v-model="form.allowed_drag">允许改变签到地点
											</el-checkbox>
										</div>
									</el-form-item>
									<!-- <el-form-item label="交通时间校验车速">
										<el-input v-model="form.validate_speed">
											<template slot="append">km/h</template>
										</el-input>
									</el-form-item> -->
									<el-form-item label="同一任务是否允许多次指派同一医生">
										<el-radio-group v-model="form.same_task_to_doctor">
											<el-radio :label="1">是</el-radio>
											<el-radio :label="0">否</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="启用现场照片相似校验">
										<el-radio-group v-model="form.picture_similar_verify" @input="enableChangePictureSimilar">
											<el-radio :label="1">是</el-radio>
											<el-radio :label="0">否</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="现场照片相似校验阈值" style="margin-bottom: 10px;" v-if="form.picture_similar_verify==1">
										<el-input v-model="form.picture_similar_verify_value" style="width: 100px;" @blur="checkSimilar()"  @input="changeMessage($event)"></el-input>
										<p style="margin: 0;line-height:30px;">默认5，数值越小，表示图片相似度越高</p>
									</el-form-item>
									
									<el-form-item label="代表拜访频次">
										<el-table :data="form.other_rule" style="width: 100%">
											<el-table-column prop="max_everyday_visit_times" label="每天拜访最大次数"
												width="180">
												<template slot-scope="{row}">
													<el-input v-model="row.max_everyday_visit_times">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_dep_interval_time"
												label="连续拜访同一医院不同科室医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_dep_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_hospital_interval_time"
												label="连续拜访同一市不同医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_hospital_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_city_interval_time"
												label="连续拜访不同市区医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_city_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_province_interval_time"
												label="连续拜访不同省的医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_province_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="continuous_task_interval_time" label="连续任务间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.continuous_task_interval_time">
													</el-input>
												</template>
											</el-table-column>
										</el-table>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit(0)">保存</el-button>
										<el-button @click="clance(0)">返回</el-button>
									</el-form-item>
								</el-form>

							</div>
						</el-tab-pane>
						<el-tab-pane label="更新日志" name="second">
							<el-table :data="tableData" style="width: 100%">
								<el-table-column type="index" label="序号" width="50">
								</el-table-column>
								<el-table-column label="操作前配置" width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.new_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column label="操作后配置 " width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.old_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column prop="create_time" width="180" label="操作时间">
								</el-table-column>
								<el-table-column prop="manager.real_name" label="操作人">
								</el-table-column>
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<el-button @click="check(scope.row,0)" type="text" size="small">查看
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div style="text-align: right;margin-top: 50px;">
								<el-pagination @size-change="handleSizeChange" :page-sizes="[20]"
									@current-change="handleCurrentChange" :current-page="cur_page" :page-size="pageNum"
									layout="total,sizes,  prev, pager, next, jumper" :total="totalCount">
								</el-pagination>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>

				<div v-show="tabPosition=='调研'">
					<el-tabs v-model="activeName1" ref="cases">
						<el-tab-pane label="传统调研规则" name="first1">
							<!-- 显示内容区 -->
							<div v-if="show1">
								<div class="tb">
									<div style="flex:0 0 35%;height: 40px;">项目</div>
									<div
										style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
										设置值</div>
									<div style="flex:0 0 30%;text-align: right;height: 40px;">
										<el-button type="primary" size="small" @click="edit(1)">编辑</el-button>
									</div>
								</div>
								<div class="tbody">
									<div class="tr">
										<div class="name">调研时间段</div>
										<div class="val">{{info.value.time_section}}</div>
									</div>
									<div class="tr">
										<div class="name">最小调研时长</div>
										<div class="val">{{info.value.min_visit_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">最大调研时长</div>
										<div class="val">{{info.value.max_visit_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">签到定位点范围</div>
										<div class="val">距离定位点 {{info.value.sign_scope}}米
											以内({{info.value.allowed_drag==1?'允许改变签到地点':'不允许改变签到地点'}})</div>
									</div>
									<div class="tr">
										<div class="name">代表每日调研同一医生最大次数</div>
										<div class="val">{{info.value.max_everyday_visit_doctor_times}} 次</div>
									</div>
									<!-- <div class="tr">
										<div class="name">交通时间校验车速</div>
										<div class="val">{{info.value.validate_speed}} km/h</div>
									</div> -->
									<div class="tr">
										<div class="name">同一任务是否允许多次调研同一医生</div>
										<div class="val" v-if="info.value.same_task_to_doctor=='0'">否</div>
										<div class="val" v-if="info.value.same_task_to_doctor=='1'">是</div>
									</div>
									<div class="tr">
										<div class="name" style="border: 0;">代表调研频次</div>
										<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													每天调研最大次数</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.max_everyday_visit_times}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													次</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续调研同一医院不同科室医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_dep_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续调研同一市不同医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_hospital_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续调研不同市区医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_city_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;">
													连续调研不同省的医院的医生需间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.different_province_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
											<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;line-height: 40px;padding-left: 10px;line-height: 40px;">
													连续任务间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.continuous_task_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 编辑内容区 -->
							<div v-if="isshow1">
								<el-form ref="form" :model="form1" label-width="160px" :rules="rules"
									style="width: 760px;">
									<el-form-item label="调研时间段">
										<el-time-picker is-range v-model="value2" format="HH:mm" value-format="HH:mm"
											range-separator="至" start-placeholder="开始时间" style="width: 100%;"
											end-placeholder="结束时间" placeholder="选择时间范围" @change="tiem2">
										</el-time-picker>
									</el-form-item>
									<el-form-item label="最小调研时长">
										<el-input v-model="form1.min_visit_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="最大调研时长">
										<el-input v-model="form1.max_visit_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="代表每日调研同一医生最大次数">
										<el-input v-model="form1.max_everyday_visit_doctor_times">
											<template slot="append">次</template>
										</el-input>
									</el-form-item>
									<el-form-item label="签到定位点范围">
										<div style="display: flex;align-items: center;">
											<el-input v-model="form1.sign_scope">
												<template slot="append">米</template>
											</el-input>
											<el-checkbox style="margin-left: 20px;" v-model="form1.allowed_drag">允许改变签到地点
											</el-checkbox>
										</div>
									</el-form-item>
									<!-- <el-form-item label="交通时间校验车速">
										<el-input v-model="form1.validate_speed">
											<template slot="append">km/h</template>
										</el-input>
									</el-form-item> -->
									<el-form-item label="同一任务是否允许多次调研同一医生">
										<el-radio-group v-model="form1.same_task_to_doctor">
											<el-radio :label="1">是</el-radio>
											<el-radio :label="0">否</el-radio>
										</el-radio-group>
									</el-form-item>
									<el-form-item label="代表调研频次">
										<el-table :data="form1.other_rule" style="width: 100%">
											<el-table-column prop="max_everyday_visit_times" label="每天调研最大次数"
												width="180">
												<template slot-scope="{row}">
													<el-input v-model="row.max_everyday_visit_times">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_dep_interval_time"
												label="连续调研同一医院不同科室医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_dep_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_hospital_interval_time"
												label="连续调研同一市不同医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_hospital_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_city_interval_time"
												label="连续调研不同市区医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_city_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_province_interval_time"
												label="连续调研不同省的医院的医生需间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.different_province_interval_time">
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="continuous_task_interval_time" label="连续任务间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.continuous_task_interval_time">
													</el-input>
												</template>
											</el-table-column>
										</el-table>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit(1)">保存</el-button>
										<el-button @click="clance(1)">返回</el-button>
									</el-form-item>
								</el-form>
							</div>
						</el-tab-pane>
						<el-tab-pane label="更新日志" name="second1">
							<el-table :data="tableData" style="width: 100%">
								<el-table-column type="index" label="序号" width="50">
								</el-table-column>
								<el-table-column label="操作前配置" width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.new_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column label="操作后配置 " width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.old_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column prop="create_time" width="180" label="操作时间">
								</el-table-column>
								<el-table-column prop="manager.real_name" label="操作人">
								</el-table-column>
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<el-button @click="check(scope.row,1)" type="text" size="small">查看
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div style="text-align: right;margin-top: 50px;">
								<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="currentPage" :page-sizes="[100, 200, 300, 400]" :page-size="100"
									layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
								</el-pagination>
							</div>
						</el-tab-pane>

					</el-tabs>

				</div>
				<div  v-show="tabPosition=='科室会'">
					<el-tabs v-model="activeName2" ref="cases1">
						<el-tab-pane label="传统科室会规则" name="first2">
							<!-- 显示内容区 -->
							<div v-if="show2">
								<div class="tb">
									<div style="flex:0 0 35%;height: 40px;">项目</div>
									<div
										style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
										设置值</div>
									<div style="flex:0 0 30%;text-align: right;height: 40px;">
										<el-button type="primary" size="small" @click="edit(2)">编辑</el-button>
									</div>
								</div>
								<div class="tbody">
									<div class="tr">
										<div class="name">最小参会人数</div>
										<div class="val">{{info.value.min_join_meeting_person}} 人</div>
									</div>
									<div class="tr">
										<div class="name">最小会议时长</div>
										<div class="val">{{info.value.min_meeting_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">最大会议时长</div>
										<div class="val">{{info.value.max_meeting_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">签到定位点范围</div>
										<div class="val">距离定位点 {{info.value.sign_scope}}米
											以内({{info.value.allowed_drag==1?'允许改变签到地点':'不允许改变签到地点'}})</div>
									</div>
									<!-- <div class="tr">
										<div class="name">交通时间校验车速</div>
										<div class="val">{{info.value.validate_speed}} km/h</div>
									</div> -->
									<div class="tr">
										<div class="name" style="border: 0;">代表开会频次</div>
										<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													每天每代表开会最大次数</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.max_everyday_meeting_times}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													次</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													每周每代表开会最大次数</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.max_month_meeting_times}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													次</div>
											</div>
											<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													连续任务间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.continuous_task_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 编辑内容区 -->
							<div v-if="isshow2">
								<el-form ref="form" :model="form2" label-width="160px" :rules="rules"
									style="width: 700px;">
									<el-form-item label="最小参会人数">
										<el-input v-model="form2.min_join_meeting_person">
											<template slot="append">人</template>
										</el-input>
									</el-form-item>
									<el-form-item label="最小会议时长">
										<el-input v-model="form2.min_meeting_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="最大会议时长">
										<el-input v-model="form2.max_meeting_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="签到定位点范围">
										<div style="display: flex;align-items: center;">
											<el-input v-model="form2.sign_scope">
												<template slot="append">米</template>
											</el-input>
											<el-checkbox style="margin-left: 20px;" v-model="form2.allowed_drag">允许改变签到地点
											</el-checkbox>
										</div>
									</el-form-item>
									<!-- <el-form-item label="交通时间校验车速">
										<el-input v-model="form2.validate_speed">
											<template slot="append">km/h</template>
										</el-input>
									</el-form-item> -->
									<el-form-item label="代表开会频次">
										<el-table :data="form2.other_rule" style="width: 100%">
											<el-table-column prop="max_everyday_visit_times" label="每天每代表开会最大次数"
												width="180">
												<template slot-scope="{row}">
													<el-input v-model="row.max_everyday_meeting_times">
														<template slot="append">次</template>
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_dep_interval_time" label="每周每代表开会最大次数">
												<template slot-scope="{row}">
													<el-input v-model="row.max_month_meeting_times">
														<template slot="append">次</template>
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="continuous_task_interval_time" label="连续任务间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.continuous_task_interval_time">
													</el-input>
												</template>
											</el-table-column>
										</el-table>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit(2)">保存</el-button>
										<el-button @click="clance(2)">返回</el-button>
									</el-form-item>
								</el-form>
							</div>
						</el-tab-pane>
						<el-tab-pane label="更新日志" name="second2">
							<el-table :data="tableData" style="width: 100%">
								<el-table-column type="index" label="序号" width="50">
								</el-table-column>
								<el-table-column label="操作前配置" width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.new_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column label="操作后配置 " width="370">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.old_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column prop="create_time" width="180" label="操作时间">
								</el-table-column>
								<el-table-column prop="manager.real_name" label="操作人">
								</el-table-column>
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<el-button @click="check(scope.row,2)" type="text" size="small">查看
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div style="text-align: right;margin-top: 50px;">
								<el-pagination @size-change="handleSizeChange" :page-sizes="[20]"
									@current-change="handleCurrentChange" :current-page="cur_page" :page-size="pageNum"
									layout="total,sizes,  prev, pager, next, jumper" :total="totalCount">
								</el-pagination>
							</div>
						</el-tab-pane>

					</el-tabs>





				</div>
				<div v-show="tabPosition=='沙龙会'">
					<el-tabs v-model="activeName3" ref="cases2">
						<el-tab-pane label="传统沙龙会规则" name="first3">
							<!-- 显示内容区 -->
							<div v-if="show3">
								<div class="tb">
									<div style="flex:0 0 35%;height: 40px;">项目</div>
									<div
										style="flex:0 0 35%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
										设置值</div>
									<div style="flex:0 0 30%;text-align: right;height: 40px;">
										<el-button type="primary" size="small" @click="edit(3)">编辑</el-button>
									</div>
								</div>
								<div class="tbody">
									<div class="tr">
										<div class="name">最小参会人数</div>
										<div class="val">{{info.value.min_join_meeting_person}} 人</div>
									</div>
									<div class="tr">
										<div class="name">最小会议时长</div>
										<div class="val">{{info.value.min_meeting_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">最大会议时长</div>
										<div class="val">{{info.value.max_meeting_time}} 分钟</div>
									</div>
									<div class="tr">
										<div class="name">签到定位点范围</div>
										<div class="val">距离定位点 {{info.value.sign_scope}}米
											以内({{info.value.allowed_drag==1?'允许改变签到地点':'不允许改变签到地点'}})</div>
									</div>
									<!-- <div class="tr">
										<div class="name">交通时间校验车速</div>
										<div class="val">{{info.value.validate_speed}} km/h</div>
									</div> -->
									<div class="tr">
										<div class="name" style="border: 0;">代表开会频次</div>
										<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													每天每代表开会最大次数</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.max_everyday_meeting_times}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													次</div>
											</div>
											<div class="tab">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													每周每代表开会最大次数</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.max_month_meeting_times}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													次</div>
											</div>
											<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
												<div
													style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
													连续任务间隔时间</div>
												<div
													style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
													{{info.value.other_rule.continuous_task_interval_time}}
												</div>
												<div
													style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
													分钟</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 编辑内容区 -->
							<div v-if="isshow3">
								<el-form ref="form" :model="form3" label-width="160px" :rules="rules"
									style="width: 700px;">
									<el-form-item label="最小参会人数">
										<el-input v-model="form3.min_join_meeting_person">
											<template slot="append">人</template>
										</el-input>
									</el-form-item>
									<el-form-item label="最小会议时长">
										<el-input v-model="form3.min_meeting_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="最大会议时长">
										<el-input v-model="form3.max_meeting_time">
											<template slot="append">分钟</template>
										</el-input>
									</el-form-item>
									<el-form-item label="签到定位点范围">
										<div style="display: flex;align-items: center;">
											<el-input v-model="form3.sign_scope">
												<template slot="append">米</template>
											</el-input>
											<el-checkbox style="margin-left: 20px;" v-model="form3.allowed_drag">允许改变签到地点
											</el-checkbox>
										</div>
									</el-form-item>
									<!-- <el-form-item label="交通时间校验车速">
										<el-input v-model="form3.validate_speed">
											<template slot="append">km/h</template>
										</el-input>
									</el-form-item> -->
									<el-form-item label="代表开会频次">
										<el-table :data="form3.other_rule" style="width: 100%">
											<el-table-column prop="max_everyday_visit_times" label="每天每代表开会最大次数"
												width="180">
												<template slot-scope="{row}">
													<el-input v-model="row.max_everyday_meeting_times">
														<template slot="append">次</template>
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="different_dep_interval_time" label="每周每代表开会最大次数">
												<template slot-scope="{row}">
													<el-input v-model="row.max_month_meeting_times">
														<template slot="append">次</template>
													</el-input>
												</template>
											</el-table-column>
											<el-table-column prop="continuous_task_interval_time" label="连续任务间隔时间">
												<template slot-scope="{row}">
													<el-input v-model="row.continuous_task_interval_time">
													</el-input>
												</template>
											</el-table-column>
										</el-table>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" @click="onSubmit(3)">保存</el-button>
										<el-button @click="clance(3)">返回</el-button>
									</el-form-item>
								</el-form>
							</div>
						</el-tab-pane>
						<el-tab-pane label="更新日志" name="second3">
							<el-table :data="tableData" style="width: 100%">
								<el-table-column type="index" label="序号" width="50">
								</el-table-column>
								<el-table-column label="操作前配置" width="380">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.new_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.new_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column label="操作后配置 " width="380">
									<template slot-scope="{row}">
										<el-popover trigger="hover" placement="top" width="300">
											<p>{{JSON.stringify(row.old_value)}}</p>
											<div slot="reference">
												<span class="ellipsis">{{JSON.stringify(row.old_value)}}></span>
											</div>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column prop="create_time" width="180" label="操作时间">
								</el-table-column>
								<el-table-column prop="manager.real_name" label="操作人">
								</el-table-column>
								<el-table-column label="操作" width="100">
									<template slot-scope="scope">
										<el-button @click="check(scope.row,3)" type="text" size="small">查看
										</el-button>
									</template>
								</el-table-column>
							</el-table>
							<div style="text-align: right;margin-top: 50px;">
								<el-pagination @size-change="handleSizeChange" :page-sizes="[20]"
									@current-change="handleCurrentChange" :current-page="cur_page" :page-size="pageNum"
									layout="total,sizes,  prev, pager, next, jumper" :total="totalCount">
								</el-pagination>
							</div>
						</el-tab-pane>

					</el-tabs>

				</div>
		</div>
		<el-drawer title="查看更新日志详情" :visible.sync="drawer" :direction="direction" size="865px">
			<div style="padding: 20px;">
				<div style="font-size: 18px;font-weight: bold;margin-bottom: 20px;">基础信息</div>
				<div class="flex">
					<div style="margin-right: 20px;">操作人：{{popinfo.manager.real_name}}</div>
					<div>编辑时间：{{popinfo.create_time}}</div>
				</div>
			</div>
			<div style="font-size: 18px;font-weight: bold;padding: 0 20px;">变更日志</div>
			<div style="padding: 20px;" v-if="tabPosition=='医院拜访' || tabPosition=='客户拜访'">
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div
						style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name">拜访时间段</div>
						<div class="val">{{popinfo.new_value.time_section}} <span class="compare"
								v-if="popinfo.compare_value.time_section==0">{{popinfo.old_value.time_section}}</span>
						</div>
					</div>
					<div class="tr">
						<div class="name">最小拜访时长</div>
						<div class="val">{{popinfo.new_value.min_visit_time}} <span class="compare"
								v-if="popinfo.compare_value.min_visit_time==0">{{popinfo.old_value.min_visit_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">最大拜访时长</div>
						<div class="val">{{popinfo.new_value.max_visit_time}} <span class="compare"
								v-if="popinfo.compare_value.max_visit_time==0">{{popinfo.old_value.max_visit_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">签到定位点范围</div>
						<div class="val">距离定位点 {{popinfo.new_value.sign_scope}} <span class="compare"
								v-if="popinfo.compare_value.sign_scope==0">{{popinfo.old_value.sign_scope}}</span>米 以内
							({{popinfo.new_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})<span class="compare"
								v-if="popinfo.compare_value.allowed_drag==0">({{popinfo.old_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})</span>
						</div>
					</div>
					<div class="tr">
						<div class="name">代表每日拜访同一医生最大次数</div>
						<div class="val">{{popinfo.new_value.max_everyday_visit_doctor_times}} <span class="compare"
								v-if="popinfo.compare_value.max_everyday_visit_doctor_times==0">{{popinfo.old_value.max_everyday_visit_doctor_times}}</span>次
						</div>
					</div>
					<!-- <div class="tr">
						<div class="name">交通时间校验车速</div>
						<div class="val">{{popinfo.new_value.validate_speed}} <span class="compare"
								v-if="popinfo.compare_value.validate_speed==0">{{popinfo.old_value.validate_speed}}</span>km/h
						</div>
					</div> -->
					<div class="tr">
						<div class="name">同一任务是否允许多次指派同一医生</div>
						<div class="val" style="flex: 0;" v-if="popinfo.new_value.same_task_to_doctor=='0'">否</div>
						<div class="val" style="flex: 0;"  v-if="popinfo.new_value.same_task_to_doctor=='1'">是</div>
						<div class="compare" v-if="popinfo.compare_value.same_task_to_doctor==0">
							<div class="" v-if="popinfo.old_value.same_task_to_doctor=='0'">否</div>
							<div class="" v-if="popinfo.old_value.same_task_to_doctor=='1'">是</div>
						</div>
					</div>
					<div class="tr">
						<div class="name">启用现场照片相似校验</div>
						<div class="val" style="flex: 0 0 auto;" v-if="popinfo.new_value.picture_similar_verify=='0'">否</div>
						<div class="val" style="flex: 0 0 auto;"  v-if="popinfo.new_value.picture_similar_verify=='1'">是，相似阈值：{{ popinfo.new_value.picture_similar_verify_value }}</div>
						<div class="compare" v-if="popinfo.compare_value.picture_similar_verify==0">
							<div class="" v-if="popinfo.old_value.picture_similar_verify=='0'">否</div>
							<div class="" v-if="popinfo.old_value.picture_similar_verify=='1'">是，相似阈值：{{ popinfo.old_value.picture_similar_verify_value }}</div>
						</div>
						<div class="compare" v-if="popinfo.compare_value.picture_similar_verify==1">
							<div class="" v-if="popinfo.old_value.picture_similar_verify=='0'">否</div>
							<div class="" v-if="popinfo.old_value.picture_similar_verify=='1'">是，相似阈值：{{ popinfo.old_value.picture_similar_verify_value }}</div>
						</div>
					</div>
					<div class="tr">
						<div class="name" style="border: 0;">代表拜访频次</div>
						<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									每天拜访最大次数</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.max_everyday_visit_times}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.max_everyday_visit_times==0">{{popinfo.old_value.other_rule.max_everyday_visit_times}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									次</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续拜访同一医院不同科室医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_dep_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_dep_interval_time==0">{{popinfo.old_value.other_rule.different_dep_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续拜访同一市不同医院的医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_hospital_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_hospital_interval_time==0">{{popinfo.old_value.other_rule.different_hospital_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续拜访不同市区医院的医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_city_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_city_interval_time==0">{{popinfo.old_value.other_rule.different_city_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续拜访不同省的医院的医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_province_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_province_interval_time==0">{{popinfo.old_value.other_rule.different_province_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>


							<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									连续任务间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.continuous_task_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.continuous_task_interval_time==0">{{popinfo.old_value.other_rule.continuous_task_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>


						</div>
					</div>
				</div>
			</div>


			<div style="padding: 20px;" v-if="tabPosition=='调研'">
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div
						style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name">调研时间段</div>
						<div class="val">{{popinfo.new_value.time_section}} <span class="compare"
								v-if="popinfo.compare_value.time_section==0">{{popinfo.old_value.time_section}}</span>
						</div>
					</div>
					<div class="tr">
						<div class="name">最小调研时长</div>
						<div class="val">{{popinfo.new_value.min_visit_time}} <span class="compare"
								v-if="popinfo.compare_value.min_visit_time==0">{{popinfo.old_value.min_visit_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">最大调研时长</div>
						<div class="val">{{popinfo.new_value.max_visit_time}} <span class="compare"
								v-if="popinfo.compare_value.max_visit_time==0">{{popinfo.old_value.max_visit_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">签到定位点范围</div>
						<div class="val">距离定位点 {{popinfo.new_value.sign_scope}} <span class="compare"
								v-if="popinfo.compare_value.sign_scope==0">{{popinfo.old_value.sign_scope}}</span>米 以内
							({{popinfo.new_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})<span class="compare"
								v-if="popinfo.compare_value.allowed_drag==0">({{popinfo.old_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})</span>
						</div>
					</div>
					<div class="tr">
						<div class="name">代表每日调研同一医生最大次数</div>
						<div class="val">{{popinfo.new_value.max_everyday_visit_doctor_times}} <span class="compare"
								v-if="popinfo.compare_value.max_everyday_visit_doctor_times==0">{{popinfo.old_value.max_everyday_visit_doctor_times}}</span>次
						</div>
					</div>
					<!-- <div class="tr">
						<div class="name">交通时间校验车速</div>
						<div class="val">{{popinfo.new_value.validate_speed}} <span class="compare"
								v-if="popinfo.compare_value.validate_speed==0">{{popinfo.old_value.validate_speed}}</span>km/h
						</div>
					</div> -->
					<div class="tr">
						<div class="name">同一任务是否允许多次调研同一医生</div>
						<div class="val" style="flex: 0;" v-if="popinfo.new_value.same_task_to_doctor=='0'">否</div>
						<div class="val" style="flex: 0;" v-if="popinfo.new_value.same_task_to_doctor=='1'">是</div>
						<div class="compare" v-if="popinfo.compare_value.same_task_to_doctor==0">
							<div class="val" v-if="popinfo.old_value.same_task_to_doctor=='0'">否</div>
							<div class="val" v-if="popinfo.old_value.same_task_to_doctor=='1'">是</div>
						</div>
					</div>
					<div class="tr">
						<div class="name" style="border: 0;">代表调研频次</div>
						<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									每天调研最大次数</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.max_everyday_visit_times}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.max_everyday_visit_times==0">{{popinfo.old_value.other_rule.max_everyday_visit_times}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									次</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续调研同一医院不同科室医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_dep_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_dep_interval_time==0">{{popinfo.old_value.other_rule.different_dep_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续调研同一市不同医院的医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_hospital_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_hospital_interval_time==0">{{popinfo.old_value.other_rule.different_hospital_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续调研不同市区医院的医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_city_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_city_interval_time==0">{{popinfo.old_value.other_rule.different_city_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
									连续调研不同省的医院的医生需间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.different_province_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.different_province_interval_time==0">{{popinfo.old_value.other_rule.different_province_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
							<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									连续任务间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.continuous_task_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.continuous_task_interval_time==0">{{popinfo.old_value.other_rule.continuous_task_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div style="padding: 20px;"  v-if="tabPosition=='科室会'">
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div
						style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name">最小参会人数</div>
						<div class="val">{{popinfo.new_value.min_join_meeting_person}} <span class="compare"
								v-if="popinfo.compare_value.min_join_meeting_person==0">{{popinfo.old_value.min_join_meeting_person}}</span>人
						</div>
					</div>
					<div class="tr">
						<div class="name">最小会议时长</div>
						<div class="val">{{popinfo.new_value.min_meeting_time}} <span class="compare"
								v-if="popinfo.compare_value.min_meeting_time==0">{{popinfo.old_value.min_meeting_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">最大会议时长</div>
						<div class="val">{{popinfo.new_value.max_meeting_time}} <span class="compare"
								v-if="popinfo.compare_value.max_meeting_time==0">{{popinfo.old_value.max_meeting_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">签到定位点范围</div>
						<div class="val">距离定位点 {{popinfo.new_value.sign_scope}} <span class="compare"
								v-if="popinfo.compare_value.sign_scope==0">{{popinfo.old_value.sign_scope}}</span>米 以内
							({{popinfo.new_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})<span class="compare"
								v-if="popinfo.compare_value.allowed_drag==0">({{popinfo.old_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})</span>
						</div>
					</div>
					<!-- <div class="tr">
						<div class="name">交通时间校验车速</div>
						<div class="val">{{popinfo.new_value.validate_speed}} <span class="compare"
								v-if="popinfo.compare_value.validate_speed==0">{{popinfo.old_value.validate_speed}}</span>km/h
						</div>
					</div> -->
					<div class="tr">
						<div class="name" style="border: 0;">代表开会频次</div>
						<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									每天每代表开会最大次数</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.max_everyday_meeting_times}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.max_everyday_meeting_times==0">{{popinfo.old_value.other_rule.max_everyday_meeting_times}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									次</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									每周每代表开会最大次数</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.max_month_meeting_times}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.max_month_meeting_times==0">{{popinfo.old_value.other_rule.max_month_meeting_times}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									次</div>
							</div>
							<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									连续任务间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.continuous_task_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.continuous_task_interval_time==0">{{popinfo.old_value.other_rule.continuous_task_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div style="padding: 20px;" v-if="tabPosition=='沙龙会'">
				<div class="tb">
					<div style="flex:0 0 40%;height: 40px;">项目</div>
					<div
						style="flex:0 0 60%;border-left: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;">
						设置值</div>
				</div>
				<div class="tbody">
					<div class="tr">
						<div class="name">最小参会人数</div>
						<div class="val">{{popinfo.new_value.min_join_meeting_person}} <span class="compare"
								v-if="popinfo.compare_value.min_join_meeting_person==0">{{popinfo.old_value.min_join_meeting_person}}</span>人
						</div>
					</div>
					<div class="tr">
						<div class="name">最小会议时长</div>
						<div class="val">{{popinfo.new_value.min_meeting_time}} <span class="compare"
								v-if="popinfo.compare_value.min_meeting_time==0">{{popinfo.old_value.min_meeting_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">最大会议时长</div>
						<div class="val">{{popinfo.new_value.max_meeting_time}} <span class="compare"
								v-if="popinfo.compare_value.max_meeting_time==0">{{popinfo.old_value.max_meeting_time}}</span>分钟
						</div>
					</div>
					<div class="tr">
						<div class="name">签到定位点范围</div>
						<div class="val">距离定位点 {{popinfo.new_value.sign_scope}} <span class="compare"
								v-if="popinfo.compare_value.sign_scope==0">{{popinfo.old_value.sign_scope}}</span>米 以内
							({{popinfo.new_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})<span class="compare"
								v-if="popinfo.compare_value.allowed_drag==0">({{popinfo.old_value.allowed_drag=='1'?'允许改变签到地点':'不允许改变签到地点'}})</span>
						</div>
					</div>
					<!-- <div class="tr">
						<div class="name">交通时间校验车速</div>
						<div class="val">{{popinfo.new_value.validate_speed}} <span class="compare"
								v-if="popinfo.compare_value.validate_speed==0">{{popinfo.old_value.validate_speed}}</span>km/h
						</div>
					</div> -->
					<div class="tr">
						<div class="name" style="border: 0;">代表开会频次</div>
						<div class="val" style="border-left: 1px solid rgba(217, 217, 217, 1);">
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									每天每代表开会最大次数</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.max_everyday_meeting_times}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.max_everyday_meeting_times==0">{{popinfo.old_value.other_rule.max_everyday_meeting_times}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									次</div>
							</div>
							<div class="tab">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									每周每代表开会最大次数</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.max_month_meeting_times}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.max_month_meeting_times==0">{{popinfo.old_value.other_rule.max_month_meeting_times}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									次</div>
							</div>
							<div class="tab" style="border-bottom: 1px solid rgba(217, 217, 217, 1);">
								<div
									style="flex:0 0 60%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;padding-left: 10px;line-height: 40px;">
									连续任务间隔时间</div>
								<div
									style="flex:0 0 20%;border-right: 1px solid rgba(217, 217, 217, 1);height: 40px;text-align: center;line-height: 40px;">
									{{popinfo.new_value.other_rule.continuous_task_interval_time}}
									<span class="compare"
										v-if="popinfo.compare_value.other_rule.continuous_task_interval_time==0">{{popinfo.old_value.other_rule.continuous_task_interval_time}}</span>
								</div>
								<div style="flex:0 0 20%;height: 40px;text-align: center;line-height: 40px;">
									分钟</div>
							</div>
						</div>
					</div>
				</div>

			</div>


		</el-drawer>
		
	</div>
</template>

<script>
	import rangetask from '../../components/rangetask/index.vue';
	export default {
		components: { rangetask },
		data() {
			return {
				tabPositiontype:null,
				rangetaskShow:false,
				tabShow:true,
				companyData: [],
				popinfo: {
					manager: {},
					new_value: {
						other_rule: {}
					},
					old_value: {
						other_rule: {}
					},
					compare_value: {
						other_rule: {}
					}
				},
				type: 'payvisit',
				drawer: false,
				drawer1: false,
				drawer2: false,
				clanceShow:false,
				drawer3: false,
				direction: 'rtl',
				info: {
					id: null,
					value: {
						other_rule: {}
					}
				},
				rules: {
					region: [{
						required: true,
						message: '请选择活动区域',
						trigger: 'change'
					}],
				},
				form: {
					allowed_drag: true,
					same_task_to_doctor: 0,
					picture_similar_verify: 0,
					current_month_used_times: 0,
					picture_similar_verify_value: 5,
					other_rule: [{
						max_everyday_visit_times: '',
						different_dep_interval_time: '',
						different_hospital_interval_time: '',
						different_city_interval_time: '',
						different_province_interval_time: ''
					}]
				},
				form1: {
					allowed_drag: true,
					same_task_to_doctor: 0,
					picture_similar_verify: 0,
					current_month_used_times: 0,
					picture_similar_verify_value: 5,
					other_rule: [{
						max_everyday_visit_times: '',
						different_dep_interval_time: '',
						different_hospital_interval_time: '',
						different_city_interval_time: '',
						different_province_interval_time: ''
					}]
				},
				form2: {
					allowed_drag: true,
					other_rule: [{
						max_everyday_meeting_times: '',
						max_month_meeting_times: '',
					}]
				},
				form3: {
					allowed_drag: true,
					other_rule: [{
						max_everyday_meeting_times: '',
						max_month_meeting_times: '',
					}]
				},
				tabisshow:false,
				tabshow:true,
				show: true,
				isshow: false,
				show1: true,
				isshow1: false,
				show2: true,
				isshow2: false,
				show3: true,
				isshow3: false,
				currentPage: 1,
				totalCount: 0,
				activeName: 'first',
				activeName1: 'first1',
				activeName2: 'first2',
				activeName3: 'first3',
				tabPosition: null,
				cur_page: 1, //默认在第一页
				pageNum: 20, //默认每页显示1条数据
				tableData: [],
				companyvalue: '',
				timeShow: false,
				timeShow1: false,
				value1: [new Date(), new Date()],
				value2: [new Date(), new Date()]
			};
		},
		mounted() {
			this.getCompanyList()

		},
		methods: {
			// 现场照片相似校验阈值检验
			checkSimilar(){
				if(this.form.picture_similar_verify_value == undefined || this.form.picture_similar_verify_value == '' || isNaN(this.form.picture_similar_verify_value)){
					this.form.picture_similar_verify_value = 5;
				}
				this.$forceUpdate();
			},
			// 强制更新现场照片相似校验阈值检验信息框的值
			changeMessage() {
				this.$forceUpdate();
			},
			tiem1(val) {
				// let s = this.filterTime(val[0])
				// let e = this.filterTime(val[1])
				// this.form.time_section = s + '~' + e
			},
			tiem2(val) {
				// let s = this.filterTime(val[0])
				// let e = this.filterTime(val[1])
				// this.form1.time_section = s + '~' + e
			},
			// 获取合作企业
			async getCompanyList() {
				let result = await this.$http.post('/Company/getCooperationCompanyList');
				if (result.data.status === 1) {
					this.companyData = result.data.data.data_list;
					this.companyvalue = result.data.data.data_list[0].id
					this.getPromoterData()
				}
			},
			async getlist() {
				let result = await this.$http.post('/ExecuteRule/getList', {
					pageSize: this.pageNum,
					ruleId: this.info.id,
					page: this.cur_page,
					type: this.type,
				});
				if (result.data.status === 1) {
					this.tableData = result.data.data.data_list;
					this.totalCount = result.data.data.count;
				}
			},
			change() {
				if(this.rangetaskShow){
					 this.$refs.child.checkgetPromoterData(this.companyvalue);
				}else{
					this.getPromoterData()
				}
			},
			async getPromoterData() {
				let result = await this.$http.post('/ExecuteRule/getRule', {
					company_id: this.companyvalue,
					type: this.type,
					belong_to: this.rangetaskShow?'remote':''
				});
				if (result.data.status === 1) {
					if (result.data.data != null) {
						this.info = result.data.data
						this.getlist()
					} else {
						this.info = {
							id: null,
							value: {
								other_rule: {
									continuous_task_interval_time: 0
								}
							}
						}
					}

				}
			},
			check(row, i) {
				this.popinfo = row
				this.drawer = true;
			},
			costPlannedAmountChange(obj){
				if (obj.index == 0) {
					this.isshow = true;
					this.show = false
				} else if (obj.index == 1) {
					this.isshow1 = true;
					this.show1 = false
				} else if (obj.index == 2) {
					this.isshow2 = true;
					this.show2 = false
				} else if (obj.index == 3) {
					this.isshow3 = true;
					this.show3 = false
				}
				this.clanceShow=obj.clanceShow
			},
			clancecostPlannedAmountChange(obj){
				if (obj.index == 0) {
					this.isshow = false;
					this.show = true
				} else if (obj.index == 1) {
					this.isshow1 = false;
					this.show1 = true
				} else if (obj.index == 2) {
					this.isshow2 = false;
					this.show2 = true
				} else if (obj.index == 3) {
					this.isshow3 = false;
					this.show3 = true
				}
				this.clanceShow=obj.clanceShow
			},
			funDifference(object, other) {
				let diff = {}
				let vChildren
				for (var key in object) {
					if (typeof object[key] === 'object' && typeof other[key] === 'object' && object[key] && other[key]) {
						vChildren = funDifference(object[key], other[key])
						if (Object.keys(vChildren).length > 0) {
							diff[key] = vChildren
						}
					} else if (object[key] !== other[key]) {
						diff[key] = object[key]
					}
				}
				if (JSON.stringify(diff) == '{}') {
					return null
				} else {
					return diff
				}
			},
			// 强制更新启用现场照片相似校验选中状态
			enableChangePictureSimilar(){
				this.$forceUpdate();
			},
			edit(i) {
				this.getPromoterData()
				let Arr = [];
				if (this.info.id != null) {
					if (i == 0) {
						this.form = JSON.parse(JSON.stringify(this.info.value))
						this.value1 = this.form.time_section.split('~')
						Arr.push(this.form.other_rule)
						this.form.other_rule = Arr;
						this.form.allowed_drag = this.form.allowed_drag == '1' ? true : false;
						if(this.form.picture_similar_verify == undefined){
							this.form.picture_similar_verify = 0;
						}else{
							this.form.picture_similar_verify = Number(this.form.picture_similar_verify);
						}
						this.form.picture_similar_verify_value = this.form.picture_similar_verify_value == undefined ? 5 : this.form.picture_similar_verify_value;
						this.form.current_month_used_times = this.form.current_month_used_times == undefined ? 0 : this.form.current_month_used_times;
					} else if (i == 1) {
						this.form1 = JSON.parse(JSON.stringify(this.info.value))
						this.value2 = this.form1.time_section.split('~')
						Arr.push(this.form1.other_rule)
						this.form1.other_rule = Arr;
						this.form1.allowed_drag = this.form1.allowed_drag == '1' ? true : false;
					} else if (i == 2) {
						this.form2 = JSON.parse(JSON.stringify(this.info.value))
						Arr.push(this.form2.other_rule)
						this.form2.other_rule = Arr;
						this.form2.allowed_drag = this.form2.allowed_drag == '1' ? true : false;
					} else if (i == 3) {
						this.form3 = JSON.parse(JSON.stringify(this.info.value))
						Arr.push(this.form3.other_rule)
						this.form3.other_rule = Arr;
						this.form3.allowed_drag = this.form3.allowed_drag == '1' ? true : false;
					}
				}
				if (i == 0) {
					this.isshow = true;
					this.show = false
				} else if (i == 1) {
					this.isshow1 = true;
					this.show1 = false
				} else if (i == 2) {
					this.isshow2 = true;
					this.show2 = false
				} else if (i == 3) {
					this.isshow3 = true;
					this.show3 = false
				}
			},
			onSubmit(i) {
				this.submitCofig(i);
			},
			submitCofig(i) {
				let params
				this.$refs['form'].validate((valid) => {
					if (valid) {
						const loading = this.$loading({
							lock: true
						});
						if (this.type == 'survey') {
							let s,
								e
							if (this.info.id !== null) {
								s = this.value2[0]
								e = this.value2[1]
							} else {
								if (typeof(this.value2[0]) == 'object') {
									s = this.filterTime(this.value2[0])
									e = this.filterTime(this.value2[1])
								} else {
									s = this.value2[0]
									e = this.value2[1]
								}
							}
							this.form1.time_section = s + '~' + e
							params = {
								company_id: this.companyvalue,
								type: this.type,
								...this.form1
							}
						}
						if (this.type == 'payvisit' || this.type == 'clientpayvisit') {
							let s,
								e
							if (this.info.id !== null) {
								s = this.value1[0]
								e = this.value1[1]
							} else {
								if (typeof(this.value1[0]) == 'object') {
									s = this.filterTime(this.value1[0])
									e = this.filterTime(this.value1[1])
								} else {
									s = this.value1[0]
									e = this.value1[1]
								}

							}

							this.form.time_section = s + '~' + e
							params = {
								company_id: this.companyvalue,
								type: this.type,
								...this.form
							}
						}
						if (this.type == 'depmeeting') {
							params = {
								company_id: this.companyvalue,
								type: this.type,
								...this.form2
							}
						}
						if (this.type == 'salon') {
							params = {
								company_id: this.companyvalue,
								type: this.type,
								...this.form3
							}
						}
						params.allowed_drag = params.allowed_drag == true ? '1' : '0';
						this.$http.post('/ExecuteRule/update', params).then(res => {
							loading.close();
							if (res.data.status == 1) {
								this.getPromoterData()
								if (i == 0) {
									this.isshow = false;
									this.show = true
								} else if (i == 1) {
									this.isshow1 = false;
									this.show1 = true
								} else if (i == 2) {
									this.isshow2 = false;
									this.show2 = true
								} else if (i == 3) {
									this.isshow3 = false;
									this.show3 = true
								}
							}

						})
					} else {
						return false;
					}
				});
			},
			clance(i) {
				if (i == 0) {
					this.isshow = false;
					this.show = true
				} else if (i == 1) {
					this.isshow1 = false;
					this.show1 = true
				} else if (i == 2) {
					this.isshow2 = false;
					this.show2 = true
				} else if (i == 3) {
					this.isshow3 = false;
					this.show3 = true
				}
			},
			indexclance(){
				this.tabShow=true
				this.clanceShow=false
				this.tabPosition=null
				this.tabPositiontype=null
				
				this.rangetaskShow=false
			},
			handleClick(types) {
				this.cur_page = 1;
				this.tableData = []
				this.tabPosition=types
				if (types == '医院拜访') {
					this.type = 'payvisit'
				} else if (types == '客户拜访') {
					this.type = 'clientpayvisit'
				} else if (types == '调研') {
					this.type = 'survey'
				} else if (types == '科室会') {
					this.type = 'depmeeting'
				} else if (types == '沙龙会') {
					this.type = 'salon'
				}
				// 解除合作企业的冻结状态
				this.isshow = false;
				this.isshow1 = false;
				this.isshow2 = false;
				this.isshow3 = false;

				// 设置规则读区域
				this.show = true;
				this.show1 = true;
				this.show2 = true;
				this.show3 = true;

				this.tabShow=false
				this.clanceShow=true
				// this.$refs.cases.$el.querySelector(".el-tabs__active-bar").style.width = "56px";
				// this.$refs.cases1.$el.querySelector(".el-tabs__active-bar").style.width = "56px";
				// this.$refs.cases2.$el.querySelector(".el-tabs__active-bar").style.width = "56px";
				this.getPromoterData()
			},
			handleClick1(types){
				if (types == '拜访') {
					this.type = 'payvisit'
				} else if (types == '调研') {
					this.type = 'survey'
				} else if (types == '科室会') {
					this.type = 'depmeeting'
				} else if (types == '沙龙会') {
					this.type = 'salon'
				}
				
				this.rangetaskShow=true
				this.tabShow=false
				this.clanceShow=true
				this.tabPositiontype=types
				
				this.isshow = false;
				this.isshow1 = false;
				this.isshow2 = false;
				this.isshow3 = false;
				
				// 设置规则读区域
				this.show = true;
				this.show1 = true;
				this.show2 = true;
				this.show3 = true;;
				
			},
			handleSizeChange(val) {
				this.pageNum = val;
				this.getlist(); //根据用户获取的每页显示页面数量显示页面
			},
			handleCurrentChange(val) {
				this.cur_page = val;
				this.getlist(); //获取用户点击的当前页后刷新页面数据
			},
			filterTime(time) {
				var date = new Date(time);
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? "0" + m : m;
				var d = date.getDate();
				d = d < 10 ? "0" + d : d;
				var h = date.getHours();
				h = h < 10 ? "0" + h : h;
				var minute = date.getMinutes();
				minute = minute < 10 ? "0" + minute : minute;
				var s = date.getSeconds();
				s = s < 10 ? "0" + s : s;
				return h + ":" + minute;
			}

		}
	};
</script>

<style lang="scss" scoped>
	.ts{
		position: relative;
		padding-left: 10px;
	}
	.ts::after{
		content: '';
		position: absolute;
		left: 0;
		top:6px;
		background: rgba(2, 167, 240, 1);
		width: 3px;
		    height: 20px;
	}
	.account-config-card {
		background: #fff;
		padding: 32px;
		border-radius: 10px;
		padding-bottom: 50px;


	}

	.tb {
		width: 800px;
		height: 40px;
		line-height: 40px;
		display: flex;
		align-items: center;
		border: 1px solid rgba(217, 217, 217, 1);
		padding: 0 10px;
		background: rgba(250, 250, 250, 1);
	}

	.tbody {
		border-left: 1px solid rgba(217, 217, 217, 1);
		border-right: 1px solid rgba(217, 217, 217, 1);
		width: 800px;

		.tr {
			padding: 0 10px;
			display: flex;
			border-bottom: 1px solid rgba(217, 217, 217, 1);
			align-items: center;

			.name {
				flex: 0 0 35%;
				padding: 10px 0;
			}

			.val {
				flex: 0 0 70%;
				padding-left: 10px;
				border-left: 1px solid rgba(217, 217, 217, 1);
				padding: 10px;

			}

			.tab {
				width: 92%;
				height: 40px;
				display: flex;
				align-items: center;
				border-top: 1px solid rgba(217, 217, 217, 1);
				border-left: 1px solid rgba(217, 217, 217, 1);
				border-right: 1px solid rgba(217, 217, 217, 1);
			}
		}
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.compare {
		color: red;
		text-decoration: line-through;
	}

	.ellipsis {
		display: -webkit-box;
		text-overflow: ellipsis;
		overflow: hidden;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.el-popover {
		height: 150px;
		overflow: auto;
	}

	.type-font{
		font-size: 14px;
		height: 35px;
		line-height:35px
	}

	/deep/.el-input--suffix .el-input__inner{
		border-radius: 25px !important;
	}
	
</style>
